import {all, call, fork, ForkEffect, select, takeEvery} from 'redux-saga/effects';
import {STOP_USER_TOUR} from '../actions/types';
import {simpleDataProvider} from '../fetchApi';
import {FETCH} from '../fetchApi/types';
import {endpointUpdateUserConfiguration, resourceCustomUsers} from '../constants';

const changeUserConfiguration = () => {
    return simpleDataProvider(FETCH, `${resourceCustomUsers}/${endpointUpdateUserConfiguration}`, {
        data: {
            enableUserTour: false,
        },
    })
        .then(data => {
            return data;
        })
        .catch(e => {
            console.error(e);
        });
};

function* processUserTourStop() {
    const autoStartEnabled = yield select((state) => state.settings.userTour.autoStart);
    if (autoStartEnabled) {
        yield call(changeUserConfiguration);
    }
}

function* getUserTourStop(): Generator<ForkEffect> {
    yield takeEvery([STOP_USER_TOUR], processUserTourStop);
}

export default function* () {
    yield all([
        fork(getUserTourStop),
    ]);
}